import type { Action } from 'svelte/action';
import type { Writable } from 'svelte/store';

interface ResizeParams {
    store: Writable<number>;
    updater: (el: HTMLElement) => number;
}

export const resize = ((el, parameter) => {
    if (!parameter) {
        return {};
    }

    const { store, updater } = parameter;

    if (ResizeObserver) {
        const resizeObserver = new ResizeObserver(() => {
            store.set(updater(el));
        });

        resizeObserver.observe(el);

        return {
            destroy() {
                resizeObserver.unobserve(el);
            },
        };
    }
}) satisfies Action<HTMLElement, ResizeParams>;
